import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import RouteChangeTracker from './components/RouteChangeTracker';
import { attachShareClickHandler } from './services/share';
import { attachReportClickHandler } from './services/report';
import './index.css';

attachShareClickHandler(document);
attachReportClickHandler(document);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <RouteChangeTracker />
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
